//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Popover } from "element-ui"
// import VocServicerQr from "./servicerQr"
export default {
  name: "VocServicer",
  components: {
    [Popover.name]: Popover
    // VocServicerQr
  },
  data() {
    return {}
  },
  methods: {
    onCallIM() {
      this.$emit("onCallIM")
    },
    onClickCallOut() {
      this.$emit("onClickCallOut")
    }
  }
}
